import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-table-summary-text',
  templateUrl: './time-table-summary-text.component.html',
  styleUrls: ['./time-table-summary-text.component.scss']
})
export class TimeTableSummaryTextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
